var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    class: { "opacity-75 cursor-not-allowed": _vm.disabled },
    attrs: {
      mode: _vm.eagerIfDirty,
      vid: _vm.name,
      name: _vm.validateAs,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _vm.label
              ? _c(
                  "label",
                  {
                    staticClass: "mb-8 block",
                    class: [classes, _vm.labelClass],
                    attrs: { for: "id_" + _vm.name }
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
                    (_vm.rules &&
                      typeof _vm.rules === "string" &&
                      _vm.rules.includes("required")) ||
                    (typeof _vm.rules === "object" && _vm.rules.required)
                      ? _c("span", { staticClass: "text-red" }, [_vm._v("*")])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "relative flex items-center",
                class: { "pointer-events-none": _vm.disabled }
              },
              [
                _c("vue-phone-number-input", {
                  ref: "input",
                  staticClass: "w-100",
                  class: {
                    "border-red":
                      errors[0] &&
                      ((classes.dirty && _vm.validAtleastOnce) ||
                        _vm.formValdiated),
                    "is-focussed": _vm.isFocussed
                  },
                  attrs: {
                    "border-radius": 0,
                    value: _vm.localValue,
                    error: true,
                    "no-flags": true,
                    "no-example": true,
                    color: "#FE5000",
                    "default-country-code": "BE",
                    "only-countries": ["BE", "NL"],
                    type: _vm.type,
                    id: "id_" + _vm.name,
                    placeholder: _vm.placeholder,
                    "aria-describedby": "description_" + _vm.name,
                    translations: _vm.translations
                  },
                  on: {
                    update: _vm.handleInput,
                    "phone-number-focused": _vm.handleFocus,
                    "phone-number-blur": _vm.handleBlur
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.showError &&
            errors[0] &&
            ((classes.dirty && _vm.validAtleastOnce) || _vm.formValdiated)
              ? _c("span", { staticClass: "text-red mt-8 block text-12" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }